import type { JsonLdValue } from "./pageData";

export const toStringArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) return [];
  return value
    .map(item => (typeof item === "string" ? item : ""))
    .filter((item): item is string => item.length > 0);
};

export const stringOrEmpty = (value: unknown): string => (typeof value === "string" ? value : "");

export const stringOrFallback = (value: unknown, fallback: string): string => {
  if (typeof value === "string" && value.length > 0) return value;
  return fallback;
};

export const getJsonLdEntries = (jsonLd: JsonLdValue | undefined, prefix = "jsonld") => {
  if (!jsonLd) return [] as Array<[string, unknown]>;
  if (Array.isArray(jsonLd)) {
    return jsonLd.map((item, index) => [`${prefix}-${index}`, item] as const);
  }
  return Object.entries(jsonLd);
};

export interface FaqEntity {
  "@type": string;
  name: string;
  acceptedAnswer: {
    "@type": string;
    text: string;
  };
}

export const extractFaqEntities = (jsonLd: JsonLdValue | undefined): FaqEntity[] => {
  if (!jsonLd) return [];

  const fragments = Array.isArray(jsonLd) ? jsonLd : Object.values(jsonLd);

  for (const fragment of fragments) {
    if (fragment && typeof fragment === "object" && "mainEntity" in fragment) {
      const mainEntity = (fragment as { mainEntity?: unknown }).mainEntity;
      if (Array.isArray(mainEntity)) {
        return mainEntity.filter((item): item is FaqEntity => {
          if (!item || typeof item !== "object") return false;
          const record = item as Record<string, unknown>;
          if (record["@type"] !== "Question" || typeof record.name !== "string") return false;

          const acceptedAnswer = record.acceptedAnswer as Record<string, unknown> | undefined;
          if (!acceptedAnswer) return false;
          return acceptedAnswer["@type"] === "Answer" && typeof acceptedAnswer.text === "string";
        });
      }
    }
  }

  return [];
};
